export var ANALYTICS_MEDIA_CHANNEL = 'media';
//# sourceMappingURL=common.js.map